import { useSkaldElements } from '@skaldaura/devkit'
import { PBoldExt, PExt } from 'components/myTags/myTags'
import PagesReader from 'components/pagesReader/pagesReader'
import PdfReader from 'components/pdfReader/pdfReader'
import { useState } from 'react'
import Popup from 'reactjs-popup'
import { Colors } from 'styles/colors'
export default function ReglementInterieur() {
   const [reglementElements] = useSkaldElements("Réglement intérieur")
   const [open, setOpen] = useState(false)

   const colorLi = Colors.gris1
   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)
   const popup2: any = (close: any) => (
      <PdfReader
         file='/REGLEMENT INTERIEUR - LE NEUBOURG.pdf'
         close={close}
         qrcode='/img/infosPratiquesRH/qrReglementInterieur.png'
      />
   )
   return (
      <div>
         <PBoldExt fontSize='24px' color={Colors.gris1}>
            LE RÈGLEMENT INTÉRIEUR
         </PBoldExt>

         <Popup
            trigger={
               <img
                  src={reglementElements.length > 0 ? reglementElements[0].value : ""}
                  style={{
                     border: `1px ${Colors.black} solid`,
                     marginBottom: '5px',
                     width: '200px',
                  }}
                  alt=''
               />
            }
            modal
            closeOnDocumentClick
            open={open}
            onOpen={openModal}
            onClose={closeModal}
         >
            <PagesReader close={closeModal} pages={reglementElements.length > 0 ? reglementElements.map((element) => element.value) : []} />
         </Popup>
         <img
            width={40}
            style={{ position: 'absolute', left: 220, bottom: 180 }}
            src={`${process.env.PUBLIC_URL}/img/picto_black.png`}
         />
         <PExt fontSize='16px' color={colorLi}>
            Cliquez pour accéder
            <br />
            au règlement intérieur.
         </PExt>
      </div>
   )
}
